import { render, staticRenderFns } from "./terminos_privacidad_servicio.vue?vue&type=template&id=a1f36b9a"
import script from "./terminos_privacidad_servicio.js?vue&type=script&lang=js&external"
export * from "./terminos_privacidad_servicio.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports